export default function Example() {
    return (
      <div className="bg-blue-700 mb-2">
        <div className="px-6 py-24 sm:px-6 sm:py-14 lg:px-8">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-balance text-4xl font-semibold tracking-tight text-white sm:text-5xl">
            Sign up now for instant access            </h2>
            <p className="mx-auto mt-6 max-w-xl text-pretty text-lg/8 text-indigo-200">
            enableSEND is the only digital platform catering to all your SEND needs
Covering a range of services and support from birth to 25!

            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              {/* First button */}
              <a
                href="/pa-signup"
                className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-indigo-600 shadow-sm hover:bg-indigo-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              >
                Parents/Carers
              </a>
              <a
                href="/la-signup"

                className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-indigo-600 shadow-sm hover:bg-indigo-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              >
                Local Authorities
              </a>

              <a
                href="/business-signup"

                className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-indigo-600 shadow-sm hover:bg-indigo-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              >
                Providers
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
  